import { InclusiveExclusiveModelComparator } from './comparators/inclusive-exclusive-model-comparator';
import {
  IFilterComparator,
  InclusiveExclusiveFilterModel,
  ConfigureOptionsParams,
  FilterOptions
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { SeriesFilterHandler } from './base/series-filter-handler';

export class SectorFilterHandler extends SeriesFilterHandler {
  private comparator: IFilterComparator<InclusiveExclusiveFilterModel>;

  get name(): string {
    return CalendarGridColumnName.Sector;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.sectors = params.filterOptions.sectors;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.sectors);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options
  ): IFilterComparator<InclusiveExclusiveFilterModel> {
    if (!this.comparator) {
      this.comparator = new InclusiveExclusiveModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }
}
